import {Component} from '@angular/core';
import {SvgSpriteIcon} from '../svg-sprite';

@Component({
  selector: 'lib-info-modal',
  standalone: true,
  templateUrl: './info-modal.component.html',
  styleUrl: './info-modal.component.scss',
})
export class InfoModalComponent {
  protected readonly SvgSpriteIcon = SvgSpriteIcon;
}
